import React from 'react';
import { ReactComponent as LocationIcon } from "../assets/footer/location-pin 1.svg";
import { ReactComponent as PhoneIcon } from "../assets/footer/call-receive 1.svg";
import { ReactComponent as MailIcon } from "../assets/footer/email 1.svg";
const Footer = () => {
  return (
    <footer className="w-full bg-[#212121] pt-[50px] md:pt-[80px] pb-[50px] md:pb-[100px] text-white">
      <div className="container max-w-[1400px] mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-4 md:gap-[64px] ">
          {/* Brand */}
          <div>
            <h3 className="text-[20px] font-[500] mb-6 tracking-tight">Zenrep
              <div className="w-10 h-[1px] mt-1 bg-[#256FFA]"></div>
            </h3>
            <p className="text-white font-[500] text-[16px] leading-relaxed tracking-[-0.5px]">
              India's leading online exam Guidearation platform for competitive exams,
              helping students achieve their dreams since 2015.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-[20px] font-[500] mb-6 tracking-tight">Zenrep
              <div className="w-10 h-[1px] mt-1 bg-[#256FFA]"></div>
            </h3>
            <ul className="space-y-3 space-y-4 text-white text-[14px]">
              <li><a href="/" className="text-white font-[500] text-[16px] leading-relaxed tracking-[-0.5px]">Home</a></li>
              <li><a href="/about" className="text-white font-[500] text-[16px] leading-relaxed tracking-[-0.5px]">About</a></li>
            </ul>
          </div>

          {/* Popular Exams */}
          <div>
            <h3 className="text-[20px] font-[500] mb-6 tracking-tight">Popular Exams
              <div className="w-10 h-[1px] mt-1 bg-[#256FFA]"></div>
            </h3>
            <ul className="space-y-4 text-white font-[500] text-[16px] leading-relaxed tracking-[-0.5px]">
              <li>UPSC Civil Services</li>
              <li>SSC CGL</li>
              <li>Banking PO/Clerk</li>
              <li>NEET UG</li>
              <li>JEE Main & Advanced</li>
            </ul>
          </div>

          {/*  Contact Us */}
          <div>
            <h3 className="text-[20px] font-[500] mb-6 tracking-tight">
              Contact Us
              <div className="w-10 h-[1px] mt-1 bg-[#256FFA]"></div>
            </h3>

            <ul className="space-y-4 text-white font-[500] text-[16px] leading-relaxed tracking-[-0.5px]">
              <li className="flex items-start gap-3 flex-shrink-0">
                <LocationIcon className="w-6 h-6 mt-1 text-[#fff] flex-shrink-0" />
                <span>123 Zencation Street, Delhi, India</span>
              </li>

              <li className="flex items-center gap-3 flex-shrink-0">
                <PhoneIcon className="w-6 h-6 mt-1 text-[#fff] flex-shrink-0" />
                <span>+91 9876543210</span>
              </li>

              <li className="flex items-center gap-3 flex-shrink-0">
                <MailIcon className="w-6 h-6 mt-1 text-[#fff] flex-shrink-0" />
                <span>support@BaapBola.com</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;